import { ButtonSimple,Text } from 'components/common'
import TitleTextCompStyle from './style'

const TitleTextComp = (props) => {
    return (
        <TitleTextCompStyle className='flexBoxColumn alignMiddle sectionMarginBottom'>
            <Text tag={'p'} className={'title NewYork h1 titleMarginBottom'} text={props.title}/>
            {props.subtitle && <Text tag={'h3'} className={'h3 PopReg subtitle subtitleMarginBottom'} text={props.subtitle}/>}
            <Text tag={'h4'} className={'content h4 PopReg'} text={props.content}/>
            {props.button && <ButtonSimple text='Create debate' />}
        </TitleTextCompStyle>
    )
}

export default TitleTextComp
